import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Zero-Touch Provisioning",
    text: "Deploy and manage networks effortlessly with automated setup that minimizes manual intervention and accelerates rollout.",
  },
  {
    image: SocImg,
    title: "Smarter Network Optimization",
    text: "Enhance performance with intelligent automation that continuously tunes and adapts your network for peak efficiency.",
  },
  {
    image: MonitoringImg,
    title: "Unified, Secure Connectivity",
    text: "Gain centralized control across wired and wireless networks—securely connecting branches, data centers, and the cloud.",
  },
];
